/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { NodeCompat } from '../../compat/NodeCompat';
import { Constants } from '../../core/Constants';
import { IDefinition } from '../../core/models/common/IDefinition';
import { IExample } from '../../core/models/common/IExample';
import { NodePathVisitor } from '../../core/visitors/NodePathVisitor';
import { IOasPropertySchema } from '../models/IOasPropertySchema';
import { OasHeader } from '../models/OasHeader';
import { OasPathItem } from '../models/OasPathItem';
import { OasPaths } from '../models/OasPaths';
import { OasResponse } from '../models/OasResponse';
import { OasResponses } from '../models/OasResponses';
import { OasSchema } from '../models/OasSchema';
import { OasXML } from '../models/OasXML';

/**
 * Constructor.
 * @class
 * @extends NodePathVisitor
 * @author eric.wittmann@gmail.com
 */
export class OasNodePathVisitor extends NodePathVisitor implements IOasVisitor {
    public constructor() {
        super();
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitPaths(io.apicurio.datamodels.openapi.models.OasPaths)
     * @param {OasPaths} node
     */
    public visitPaths(node : OasPaths) {
        this.path.prependSegment(Constants.PROP_PATHS, false);
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitPathItem(io.apicurio.datamodels.openapi.models.OasPathItem)
     * @param {OasPathItem} node
     */
    public visitPathItem(node : OasPathItem) {
        this.path.prependSegment(node.getPath(), true);
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitResponses(io.apicurio.datamodels.openapi.models.OasResponses)
     * @param {OasResponses} node
     */
    public visitResponses(node : OasResponses) {
        this.path.prependSegment(Constants.PROP_RESPONSES, false);
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitResponse(io.apicurio.datamodels.openapi.models.OasResponse)
     * @param {OasResponse} node
     */
    public visitResponse(node : OasResponse) {
        if(node.getName() == null) {
            this.path.prependSegment(Constants.PROP_DEFAULT, false);
        } else {
            this.path.prependSegment(node.getName(), true);
        }
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitXML(io.apicurio.datamodels.openapi.models.OasXML)
     * @param {OasXML} node
     */
    public visitXML(node : OasXML) {
        this.path.prependSegment(Constants.PROP_XML, false);
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitAllOfSchema(io.apicurio.datamodels.openapi.models.OasSchema)
     * @param {OasSchema} node
     */
    public visitAllOfSchema(node : OasSchema) {
        let idx : number = NodeCompat.indexOf(node, node.parent(), Constants.PROP_ALL_OF);
        if(idx !== -1) {
            this.path.prependSegment(/* valueOf */new String(idx).toString(), true);
            this.path.prependSegment(Constants.PROP_ALL_OF, false);
        }
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitItemsSchema(io.apicurio.datamodels.openapi.models.OasSchema)
     * @param {OasSchema} node
     */
    public visitItemsSchema(node : OasSchema) {
        if(node.hasItemsSchemas()) {
            let idx : number = NodeCompat.indexOf(node, node.parent(), Constants.PROP_ITEMS);
            if(idx !== -1) {
                this.path.prependSegment(/* valueOf */new String(idx).toString(), true);
                this.path.prependSegment(Constants.PROP_ITEMS, false);
            }
        } else {
            this.path.prependSegment(Constants.PROP_ITEMS, false);
        }
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitAdditionalPropertiesSchema(io.apicurio.datamodels.openapi.models.OasSchema)
     * @param {OasSchema} node
     */
    public visitAdditionalPropertiesSchema(node : OasSchema) {
        this.path.prependSegment(Constants.PROP_ADDITIONAL_PROPERTIES, false);
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitPropertySchema(io.apicurio.datamodels.openapi.models.IOasPropertySchema)
     * @param {*} node
     */
    public visitPropertySchema(node : IOasPropertySchema) {
        this.path.prependSegment(node.getPropertyName(), true);
        this.path.prependSegment(Constants.PROP_PROPERTIES, false);
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitHeader(io.apicurio.datamodels.openapi.models.OasHeader)
     * @param {OasHeader} node
     */
    public visitHeader(node : OasHeader) {
        this.path.prependSegment(node.getName(), true);
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitResponseDefinition(io.apicurio.datamodels.core.models.common.IDefinition)
     * @param {*} node
     */
    public visitResponseDefinition(node : IDefinition) {
        this.path.prependSegment(node.getName(), true);
    }

    /**
     * @see io.apicurio.datamodels.openapi.visitors.IOasVisitor#visitExample(io.apicurio.datamodels.core.models.common.IExample)
     * @param {*} node
     */
    public visitExample(node : IExample) {
        throw Object.defineProperty(new Error("Must be implemented by subclasses."), '__classes', { configurable: true, value: ['java.lang.Throwable','java.lang.Object','java.lang.RuntimeException','java.lang.Exception'] });
    }
}
OasNodePathVisitor["__class"] = "io.apicurio.datamodels.openapi.visitors.OasNodePathVisitor";
OasNodePathVisitor["__interfaces"] = ["io.apicurio.datamodels.core.visitors.IVisitor","io.apicurio.datamodels.openapi.visitors.IOasVisitor"];





import { IOasVisitor } from './IOasVisitor';

